import { Checkbox, Label } from '@headlessui/react';
import type { FormFieldDto } from '../../form.types';

interface FormFieldCheckboxProps {
    field: FormFieldDto;
}

export function FormFieldCheckbox({ field }: FormFieldCheckboxProps) {
    return (
        <div className="md:col-span-2">
            {field.choices?.map((choice) => (
                <div key={choice.value} className="flex items-center gap-2">
                    <Checkbox name={`${field.name}[]`} value={choice.value} className="form-checkbox" />
                    <Label>{choice.label}</Label>
                </div>
            ))}
        </div>
    );
}
